import React, { createContext, useEffect, useState } from 'react';

// Create UserContext
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUserData = localStorage.getItem('user');
        if (storedUserData) {
            const parsedData = JSON.parse(storedUserData);
            setUser(parsedData); // Set the user data (token and uuid) from the stored JSON object
        }
    }, []);

    // Save the user token to localStorage whenever it changes
    useEffect(() => {
        if (user) {
            localStorage.setItem('user', JSON.stringify(user)); // Save as JSON string
        } else {
            //localStorage.removeItem('user'); // Remove if userToken is null (e.g., logout)
        }
    }, [user]);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};